module.exports = __webpack_public_path__ + "static/assets/feb31898ca0a3da73fea57bf61b5cf78.svg";